/** @format */

import { ProductListSEO } from '@shared/data-access/interfaces';

import { CategoryDao } from './category.dao';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CategoryService {
  private readonly categoryDao = inject(CategoryDao);

  /**
   * @description
   * Gets a category name by a given ID
   */
  public getCategoryNameByID$(categoryId: string, retries = 0): Observable<ProductListSEO> {
    return this.categoryDao.getCategoryNameByID$(categoryId, retries);
  }

  /**
   * @description
   * Accepts fullImage and returns updated imagePath
   */
  public getimagePath(fullImage) {
    let imgPath = fullImage;
    if (imgPath !== null && !imgPath.includes('www') && !imgPath.includes('scene7')) {
      const img = imgPath.split('://');
      imgPath = `${img[0]}://www.${img[1]}`;
    }
    return imgPath;
  }
}
